import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { useLanguage } from "contexts/language.context";
import { useEffect, useMemo, useState } from "react";
import baseEntitiesService from "services/base-entities-service";
import DropdownSelect from "../DropdownSelect";
import { usePermissionMonitor } from "../PermissionMonitor";

export default function BaseEntitySelectionGrid({
  baseEntityId,
  setBaseEntityId,
  level = ["baseEntity"],
  xs,
}) {
  const { label } = useLanguage();
  const [options, setOptions] = useState({
    baseEntities: [],
  });
  const [loading, setLoading] = useState({
    baseEntities: false,
  });

  useEffect(() => {
    async function initFetch() {
      if (level.includes("baseEntity")) {
        setLoading((l) => ({ ...l, baseEntities: true }));
        const [ok, data] = await baseEntitiesService.getBaseEntities({
          raw: true,
        });
        if (ok) setOptions((prev) => ({ ...prev, baseEntities: data }));
        setLoading((l) => ({ ...l, baseEntities: false }));
      }
    }

    initFetch();
  }, []);

  const dropdownOptions = useMemo(() => {
    return {
      baseEntities:
        options.baseEntities?.map((baseEntity) => ({
          id: baseEntity.id,
          label: baseEntity.name,
        })) || [],
    };
  }, [options, baseEntityId]);

  const handleBaseEntityChange = (newBaseEntityId) => {
    setBaseEntityId(newBaseEntityId);
  };

  return (
    <>
      {level.map((lvl) => {
        let value,
          onChange,
          selectorOptions,
          loadingElement,
          labelElement,
          groupBy;

        if (lvl === "baseEntity") {
          value = baseEntityId;
          onChange = handleBaseEntityChange;
          selectorOptions = dropdownOptions.baseEntities;
          loadingElement = loading.baseEntities;
          labelElement = "Base entity";
        }

        return (
          <Selector
            key={lvl}
            value={value}
            onChange={onChange}
            options={selectorOptions}
            loading={loadingElement}
            label={labelElement}
            groupBy={groupBy}
            xs={xs}
          />
        );
      })}
    </>
  );
}

function Selector({
  label,
  value,
  onChange,
  options,
  loading,
  groupBy,
  xs = 12,
}) {
  const can = usePermissionMonitor();
  const { label: languageLabel } = useLanguage();
  return (
    <>
      <Grid item xs={can("isAdmin") ? xs * (2 / 3) : xs}>
        <DropdownSelect
          label={label}
          items={options}
          initialValue={value || ""}
          disabled={can("isAdmin") ? !value : false}
          required
          onChange={(newValue) => {
            onChange(newValue?.id || null);
          }}
          disableClearable={true || !can("isAdmin")}
          loading={loading}
          groupBy={groupBy}
        />
      </Grid>
      {can("isAdmin") ? (
        <Grid item xs={xs * (1 / 3)}>
          <FormControlLabel
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            label={
              <Typography
                sx={(theme) => ({
                  fontSize: "14px",
                  fontWeight: "450",
                  lineHeight: "16px",
                  whiteSpace: "nowrap",
                  color: theme.palette.text.primary,
                })}
              >
                {languageLabel("available-for-everyone")
                  .trim()
                  .split(" ")
                  .map((v, i) =>
                    i == 0 ? (
                      <>
                        {v}
                        <br />
                      </>
                    ) : (
                      v + " "
                    ),
                  )}
              </Typography>
            }
            control={
              <Checkbox
                checked={!value}
                onChange={(e) => {
                  if (!e.target.checked) {
                    onChange(options?.[0]?.id || -1);
                  } else {
                    onChange(null);
                  }
                }}
              />
            }
          />
        </Grid>
      ) : null}
    </>
  );
}
